export default "__VITE_ASSET__DzEueOND__"